import { useEffect, useState } from 'react';
import {
  fetchLithologyDictionary,
  fetchGenesisStratigraphyDictionary,
  fetchMineralRockDictionary,
  fetchRockSubcategoryDictionary,
} from '../firebase/dictionaries';
import { fetchProjectLayerColors } from '../firebase/boreholeBrowser';

/**
 * Slowniki globalne (3 kolekcje) + slownik numerow warstw per Firestore-project.
 * Globalne ladowane raz przy mountcie, per-project odswiezany przy zmianie sourceProjectId.
 *
 * sourceProjectId moze byc null jesli aktualny projekt nie ma jeszcze otworow z bazy zrodlowej.
 */
export function useLithologyDictionaries(sourceProjectId) {
  const [lithoDict, setLithoDict] = useState([]);
  const [genesisDict, setGenesisDict] = useState([]);
  const [rockDict, setRockDict] = useState([]);
  const [rockSubDict, setRockSubDict] = useState([]);
  const [numberDict, setNumberDict] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    Promise.all([
      fetchLithologyDictionary(),
      fetchGenesisStratigraphyDictionary(),
      fetchMineralRockDictionary(),
      fetchRockSubcategoryDictionary(),
    ]).then(([litho, genesis, rock, rockSub]) => {
      if (!alive) return;
      console.log('[dictionaries] loaded counts:', {
        catSoilLithology: litho.length,
        catGenesisAndStratiography: genesis.length,
        catMineralRockSoils: rock.length,
        subCatRockySoil: rockSub.length,
      });
      if (rockSub.length === 0) {
        console.warn('[dictionaries] subCatRockySoil pusta — podkategorie skal w dialogu beda niewidoczne');
      } else {
        console.log('[dictionaries] subCatRockySoil sample:', rockSub.slice(0, 5).map(e => e.fullString));
      }
      setLithoDict(litho);
      setGenesisDict(genesis);
      setRockDict(rock);
      setRockSubDict(rockSub);
      setLoaded(true);
    });
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (!sourceProjectId) {
      setNumberDict([]);
      return;
    }
    let alive = true;
    fetchProjectLayerColors(sourceProjectId).then(colorsMap => {
      if (!alive) return;
      // colorsMap to { "IIa": "#c69658", ... } — zamieniamy na liste { id, color }
      const entries = Object.entries(colorsMap || {})
        .map(([id, color]) => ({ id, color }))
        .sort((a, b) => a.id.localeCompare(b.id, 'pl'));
      setNumberDict(entries);
    });
    return () => { alive = false; };
  }, [sourceProjectId]);

  return { lithoDict, genesisDict, rockDict, rockSubDict, numberDict, loaded };
}
